import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

export default function usePageBack(fallback = '/') {
  const navigate = useNavigate();

  return useCallback(() => {
    // BrowserRouter's index survives reloads and excludes history from other
    // sites. history.length alone cannot tell whether Back stays in the store.
    const index = window.history.state?.idx;
    if (Number.isInteger(index) && index > 0) {
      navigate(-1);
      return;
    }

    // Replace direct entries so Back cannot loop between the page and fallback.
    navigate(fallback, { replace: true });
  }, [fallback, navigate]);
}
